
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { formatNumber } from '@/i18n';

import BannerStandOrder from '@/store/modules/banner-stand-orders/banner-stand-order';

import tableViewMixin from '@/components/mixins/table-view';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import TableListSkeleton from '@/components/skeletons/table-list.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import PaginationControl from '@/components/controls/pagination.vue';
import BannerStandOrderModal from '@/components/layout/banner-stand-order-modal.vue';
import BannerStandOrdersFilter from '@/components/forms/banner-stand-orders-filter.vue';

export default mixins(tableViewMixin).extend({
  name: 'BannerStandOrdersView',
  components: {
    NotificationBanner,
    TableListSkeleton,
    Dropdown,
    PaginationControl,
    BannerStandOrderModal,
    BannerStandOrdersFilter,
  },
  data() {
    return {
      isOrderModalOpen: false,
      selectedOrder: null as BannerStandOrder | null,
    };
  },
  computed: {
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    ...mapState('bannerStandOrders', {
      items: 'list',
      pagination: 'listPagination',
    }),
    ...mapGetters('bannerStandOrders', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
      isEmpty: 'listIsEmpty',
    }),
  },
  methods: {
    formatNumber,
    hasImages(order: BannerStandOrder): boolean {
      return order.items && order.items.some((item) => item.image && item.image.thumbnail);
    },
    formatDate(dateString: string): string {
      try {
        return format(parseISO(dateString), 'M/d/yyyy');
      } catch {
        return dateString;
      }
    },
    getStatusLabel(status: string): string {
      const labels: Record<string, string> = {
        pending: this.$t('Pending'),
        processing: this.$t('Processing'),
        completed: this.$t('Completed'),
        cancelled: this.$t('Cancelled'),
      };
      return labels[status] || status;
    },
    dropdownItems(order: BannerStandOrder) {
      const items: DropdownItems = {
        view: {
          label: this.$t('View Details'),
          icon: 'eye',
        },
      };

      return items;
    },
    handleClick(order: BannerStandOrder, action: string) {
      if ('view' === action) {
        this.openOrderModal(order);
      }
    },
    openOrderModal(order: BannerStandOrder) {
      this.selectedOrder = order;
      this.isOrderModalOpen = true;
    },
    closeOrderModal() {
      this.isOrderModalOpen = false;
      this.selectedOrder = null;
    },
  },
});
